import React, { useState, useEffect } from 'react';
import { objectivesApi, clustersApi, divisionsApi, kpisApi, risksApi, initiativesApi, financialYearsApi, roleRatesApi, researchThemesApi, motivationTopicsApi } from '../services/api';

const input = "w-full px-3 py-2.5 bg-white/90 border border-slate-300 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#a30d24]/20 focus:border-[#a30d24] transition-colors shadow-inner";
const btnPrimary = "px-4 py-2.5 bg-gradient-to-b from-[#c8102e] to-[#8f0b1f] text-white rounded-xl text-sm font-bold hover:from-[#b50e29] hover:to-[#7d091b] transition-all flex items-center gap-2 shadow-lg shadow-[#8f0b1f]/25 border border-[#8f0b1f]/40";
const btnSecondary = "px-4 py-2.5 bg-gradient-to-b from-white to-slate-200 text-slate-700 rounded-xl text-sm font-semibold hover:to-slate-300 transition-colors border border-slate-300 shadow-sm";


const ADMIN_PAGE_CSS = `
  .silogate-admin {
    min-height: calc(100vh - 24px);
    padding: 8px 10px 22px;
    background:
      radial-gradient(circle at 82% 18%, rgba(255,255,255,.88), transparent 28%),
      linear-gradient(135deg, #f7f7f5 0%, #f1f2f4 42%, #e5e7eb 100%);
    color: #151922;
  }
  .silogate-admin::after {
    content: '✦';
    position: fixed;
    right: 34px;
    bottom: 28px;
    color: rgba(255,255,255,.75);
    font-size: 76px;
    line-height: 1;
    pointer-events: none;
    text-shadow: 0 18px 45px rgba(15,23,42,.10);
  }
  .admin-title {
    color: #4b5563;
    font-size: 24px;
    line-height: 1;
    font-weight: 800;
    letter-spacing: -0.035em;
    text-shadow: 0 1px 0 rgba(255,255,255,.85);
  }
  .admin-subtitle { color: #111827; font-size: 13px; margin-top: 4px; }
  .admin-tabs {
    background: linear-gradient(180deg, #d6d8dc 0%, #9da2aa 100%);
    border: 1px solid rgba(148,163,184,.62);
    border-radius: 8px;
    padding: 0;
    min-height: 42px;
    box-shadow: inset 0 1px 0 rgba(255,255,255,.55), 0 16px 35px rgba(15,23,42,.08);
  }
  .admin-tab {
    height: 42px;
    padding: 0 14px;
    border-right: 1px solid rgba(255,255,255,.22);
    border-radius: 0;
    color: #1f2937;
    font-weight: 700;
    font-size: 13px;
    transition: all .18s ease;
    white-space: nowrap;
  }
  .admin-tab:first-child { border-top-left-radius: 8px; border-bottom-left-radius: 8px; }
  .admin-tab:hover { background: rgba(255,255,255,.22); }
  .admin-tab-active {
    background: linear-gradient(180deg, #c8102e 0%, #8e0b1f 100%);
    color: white;
    box-shadow: 0 9px 18px rgba(142,11,31,.36), inset 0 1px 0 rgba(255,255,255,.18);
    position: relative;
    z-index: 1;
  }
  .admin-card, .silogate-admin .bg-white {
    background: rgba(255,255,255,.78);
    border-color: #aeb4bd;
    box-shadow: 0 10px 26px rgba(15,23,42,.08), inset 0 1px 0 rgba(255,255,255,.75);
  }
  .silogate-admin table thead tr {
    background: linear-gradient(180deg, #f5f6f8 0%, #d9dce1 100%);
  }
  .silogate-admin table th { color: #374151; }
  .silogate-admin h3, .silogate-admin h4 { letter-spacing: -0.015em; }
  .mintek-watermark {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 124px;
    color: rgba(100,116,139,.38);
    font-weight: 700;
    pointer-events: none;
    font-size: 13px;
  }
  .cluster-section-design {
    background: rgba(255,255,255,.72);
    border: 1px solid #b7bdc6;
    border-radius: 8px;
    padding: 18px 16px 16px;
    box-shadow: inset 0 1px 0 rgba(255,255,255,.9);
  }
  .cluster-section-head {
    display:flex;
    align-items:flex-start;
    justify-content:space-between;
    gap:16px;
    margin-bottom:18px;
  }
  .cluster-title-red {
    color:#9b0d24;
    font-size:16px;
    line-height:1.1;
    font-weight:800;
  }
  .cluster-desc {
    color:#111827;
    font-size:11px;
    font-weight:600;
    margin-top:4px;
  }
  .tech-division-card {
    min-height:130px;
    background:rgba(255,255,255,.86);
    border:1px solid #aeb4bd;
    border-radius:8px;
    padding:18px 16px 12px;
    box-shadow:0 1px 2px rgba(15,23,42,.08), inset 0 1px 0 rgba(255,255,255,.9);
    position:relative;
  }
  .tech-icon-wrap {
    height:58px;
    display:flex;
    align-items:center;
    justify-content:center;
    font-size:40px;
    color:#9b0d24;
    filter: drop-shadow(0 1px 0 rgba(255,255,255,.8));
  }
  .division-actions {
    position:absolute;
    right:14px;
    top:50%;
    transform:translateY(-50%);
    display:flex;
    gap:8px;
  }
  .support-area-design {
    margin-top: 12px;
    padding: 0;
  }
  .support-division-card {
    min-height:112px;
    background:rgba(255,255,255,.88);
    border:1px solid #c7ccd4;
    border-radius:8px;
    padding:20px 18px;
    box-shadow:0 7px 15px rgba(15,23,42,.10), inset 0 1px 0 rgba(255,255,255,.9);
    display:flex;
    align-items:flex-start;
    gap:16px;
    position:relative;
  }
  .support-icon-box {
    width:58px;
    height:58px;
    min-width:58px;
    border-radius:8px;
    background:linear-gradient(180deg,#eef0f3,#d7dbe1);
    display:flex;
    align-items:center;
    justify-content:center;
    font-size:30px;
    box-shadow:inset 0 1px 0 rgba(255,255,255,.9);
  }

`;

const RESPONSIBLE_OWNERS = ['Executive Managers','Head: MOTT','Head: Artisanal and Small-Scale Mining Training','Executive Manager: Finance','Head: Mine closure and rehabilitation','Executive Manager: HR','Executive Manager: RDI','Head: SHEQ & ERM','Head: Supply Chain Management'];
const UNIT_FUNCTIONS = ['Sum','Last','Min','Max','Average','LessThan','MoreThan','Compliance','Status'];
const UNIT_FUNCTION_LABELS = {Sum:'Sum',Last:'Last',Min:'Min',Max:'Max',Average:'Average',LessThan:'Less than',MoreThan:'More than',Compliance:'Compliance',Status:'Status'};
const UNITS = ['Count','%','R million','None'];
const RDI_OPS_FUNCTIONS = ['Planning, Monitoring, Evaluation, and Reporting (PMER)','R&D Management','Business Development and Commercialisation','Communications','Safety, Health, Environment and Quality (SHEQ), and Enterprise Risk Management (ERM)'];

function Modal({open, onClose, title, wide, children}) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-50 flex items-start justify-center pt-[8vh] overflow-y-auto" onClick={onClose}>
      <div className={`bg-white rounded-2xl shadow-2xl ${wide?'max-w-3xl':'max-w-2xl'} w-full mx-4 mb-8`} onClick={e=>e.stopPropagation()} style={{animation:'slideUp .25s ease-out'}}>
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
          <h3 className="font-bold text-lg text-slate-800">{title}</h3>
          <button onClick={onClose} className="w-8 h-8 rounded-full hover:bg-slate-100 flex items-center justify-center text-slate-400">✕</button>
        </div>
        <div className="px-6 py-5">{children}</div>
      </div>
    </div>
  );
}
function Field({label, children, hint, required}) {
  return (<div className="mb-4"><label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1.5">{label}{required&&<span className="text-red-500 ml-0.5">*</span>}</label>{children}{hint && <p className="text-[10px] text-slate-400 mt-1">{hint}</p>}</div>);
}

// ════════════════════════════════════════
// TAB 1: STRATEGIC OBJECTIVES
// ════════════════════════════════════════
function ObjectivesTab() {
  const [objectives, setObjectives] = useState([]);
  const [expanded, setExpanded] = useState({});
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({});
  const [refPool, setRefPool] = useState([]);
  const [usedRefs, setUsedRefs] = useState([]);
  const [fy, setFy] = useState(2026);

  useEffect(() => { load(); }, [fy]);
  const load = async () => {
    try {
      const [soRes, usedRes] = await Promise.all([objectivesApi.getAll(fy), objectivesApi.getUsedReferences()]);
      setObjectives(soRes.data || []);
      const taken = usedRes.data || [];
      setUsedRefs(taken);
      const maxNum = Math.max(...taken.map(r => parseInt(r?.replace('SO-',''))||0), (soRes.data||[]).length, 6);
      const pool = [];
      for (let i = 1; i <= maxNum + 2; i++) pool.push(`SO-${String(i).padStart(2,'0')}`);
      setRefPool(pool);
    } catch {}
  };

  const availableRefs = refPool.filter(r => !usedRefs.includes(r));
  const addMoreRef = () => {
    const maxNum = refPool.length > 0 ? parseInt(refPool[refPool.length-1].replace('SO-',''))||0 : 0;
    setRefPool([...refPool, `SO-${String(maxNum+1).padStart(2,'0')}`]);
  };

  const openAdd = () => { setForm({title:'',description:'',sortOrder:objectives.length+1,financialYear:fy,weighting:0,reference:availableRefs[0]||''}); setModal('add'); };
  const openEdit = (so) => { setForm({...so}); setModal('edit'); };
  const handleSave = async () => {
    if (!form.reference) { alert('Please select a reference number'); return; }
    try { if (modal === 'add') await objectivesApi.create(form); else await objectivesApi.update(form.id, form); setModal(null); load(); }
    catch(e) { alert('Error: ' + (e.response?.data?.error || e.message)); }
  };
  const handleDelete = async (id) => { if(window.confirm('Delete this objective?')) { await objectivesApi.delete(id).catch(()=>{}); load(); }};

  return (
    <div>
      <div className="flex items-center justify-between mb-5">
        <div><p className="text-sm text-slate-500">{objectives.length} strategic objectives for FY {fy-1}/{fy%100}</p><p className="text-[10px] text-slate-400 mt-0.5">Select a reference number from the dropdown when creating an objective.</p></div>
        <div className="flex items-center gap-2">
          <select className={input+' max-w-[130px]'} value={fy} onChange={e=>setFy(+e.target.value)}><option value={2025}>FY 24/25</option><option value={2026}>FY 25/26</option><option value={2027}>FY 26/27</option><option value={2028}>FY 27/28</option></select>
          <button onClick={openAdd} className={btnPrimary}><span className="text-lg leading-none">+</span> Add Objective</button>
        </div>
      </div>
      <div className="space-y-2">
        {objectives.map(so => (
          <div key={so.id} className="bg-white rounded-xl border border-slate-200 overflow-hidden hover:shadow-sm transition-shadow">
            <div className="flex items-center gap-3 p-4 cursor-pointer" onClick={() => setExpanded(p=>({...p,[so.id]:!p[so.id]}))}>
              <span className="text-slate-400">{expanded[so.id] ? '▾' : '▸'}</span>
              <span className="font-mono text-[10px] font-bold text-[#c8102e] bg-red-50 px-2 py-0.5 rounded-md">{so.reference}</span>
              <span className="flex-1 text-sm font-semibold text-slate-700">{so.title}</span>
              {so.weighting > 0 && <span className="text-[10px] font-bold text-blue-600 bg-blue-50 px-2 py-0.5 rounded">{so.weighting}%</span>}
              <span className="text-[10px] text-slate-400">{(so.kpis||[]).length} KPIs · {(so.initiatives||[]).length} Programmes</span>
              <button onClick={e=>{e.stopPropagation();openEdit(so);}} className="p-1.5 rounded-lg hover:bg-slate-100 text-slate-400 text-xs">✏️</button>
              <button onClick={e=>{e.stopPropagation();handleDelete(so.id);}} className="p-1.5 rounded-lg hover:bg-red-50 text-red-400 text-xs">🗑️</button>
            </div>
            {expanded[so.id] && (
              <div className="px-4 pb-4 border-t border-slate-100 pt-3 bg-slate-50/30">
                <p className="text-xs text-slate-500 mb-3">{so.description}</p>
                {(so.kpis||[]).length > 0 && (<div><p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-2">Linked KPI Measures</p>
                  {so.kpis.map(kpi => (<div key={kpi.id} className="flex items-center gap-2 py-1.5 text-xs"><span className="font-mono text-[10px] text-emerald-600 bg-emerald-50 px-1.5 py-0.5 rounded">{kpi.reference}</span><span className="text-slate-600 flex-1">{kpi.name}</span></div>))}
                </div>)}
                {(so.initiatives||[]).length > 0 && (<div className="mt-3"><p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-2">Linked Programmes</p>
                  {so.initiatives.map(init => (<div key={init.id} className="flex items-center gap-2 py-1 text-xs"><span className="font-mono text-[10px] text-blue-600 bg-blue-50 px-1.5 py-0.5 rounded">{init.reference}</span><span className="text-slate-600">{init.title}</span></div>))}
                </div>)}
              </div>
            )}
          </div>
        ))}
      </div>
      <Modal open={!!modal} onClose={()=>setModal(null)} title={modal==='add' ? 'Add Strategic Objective' : 'Edit Strategic Objective'}>
        <div className="space-y-4">
          <Field label="Reference Number" required>
            <div className="flex gap-2">
              <select className={input+' flex-1'} value={form.reference||''} onChange={e=>setForm({...form,reference:e.target.value})}>
                <option value="">— Select Reference —</option>
                {modal==='edit' && form.reference && <option value={form.reference}>{form.reference} (current)</option>}
                {availableRefs.map(r => <option key={r} value={r}>{r}</option>)}
              </select>
              <button type="button" onClick={addMoreRef} className="px-3 py-2 bg-slate-100 hover:bg-slate-200 rounded-xl text-sm font-bold text-slate-600 whitespace-nowrap" title="Add next sequential reference">+ Add</button>
            </div>
            <p className="text-[10px] text-slate-400 mt-1">{availableRefs.length} available · Click "+ Add" to create more</p>
          </Field>
          <Field label="Title" required><input className={input} value={form.title||''} onChange={e=>setForm({...form,title:e.target.value})} placeholder="e.g. Advance mineral beneficiation research" /></Field>
          <Field label="Description"><textarea className={input} rows={3} value={form.description||''} onChange={e=>setForm({...form,description:e.target.value})} /></Field>
          <div className="grid grid-cols-3 gap-3">
            <Field label="Financial Year" required><select className={input} value={form.financialYear||fy} onChange={e=>setForm({...form,financialYear:+e.target.value})}><option value={2025}>FY 24/25</option><option value={2026}>FY 25/26</option><option value={2027}>FY 26/27</option><option value={2028}>FY 27/28</option></select></Field>
            <Field label="Sort Order"><input type="number" className={input} value={form.sortOrder||''} onChange={e=>setForm({...form,sortOrder:+e.target.value})} /></Field>
            <Field label="Weighting (%)" required><input type="number" step="0.01" className={input} value={form.weighting||''} onChange={e=>setForm({...form,weighting:+e.target.value})} placeholder="e.g. 15" /></Field>
          </div>
          <div className="flex justify-end gap-2 pt-2"><button onClick={()=>setModal(null)} className={btnSecondary}>Cancel</button><button onClick={handleSave} className={btnPrimary}>💾 {modal==='add' ? 'Create' : 'Save'}</button></div>
        </div>
      </Modal>
      <style>{`@keyframes slideUp { from { opacity:0; transform:translateY(16px); } to { opacity:1; transform:translateY(0); } }`}</style>
    </div>
  );
}

// ════════════════════════════════════════
// TAB 2: RDI & INDUSTRY PROGRAMMES
// ════════════════════════════════════════
function ProgrammesTab() {
  const [initiatives, setInitiatives] = useState([]);
  const [objectives, setObjectives] = useState([]);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({});
  const [selectedSoIds, setSelectedSoIds] = useState([]);
  const [refPool, setRefPool] = useState([]);
  const [usedRefs, setUsedRefs] = useState([]);
  const [fy, setFy] = useState(2026);

  useEffect(() => { load(); }, [fy]);
  const load = async () => {
    try {
      const [initRes, soRes, usedRes] = await Promise.all([initiativesApi.getAll(), objectivesApi.getAll(fy), initiativesApi.getUsedReferences()]);
      setInitiatives(initRes.data || []); setObjectives(soRes.data || []);
      const taken = usedRes.data || [];
      setUsedRefs(taken);
      const maxNum = Math.max(...taken.map(r => parseInt(r?.replace('INIT-',''))||0), (initRes.data||[]).length, 4);
      const pool = [];
      for (let i = 1; i <= maxNum + 2; i++) pool.push(`INIT-${String(i).padStart(2,'0')}`);
      setRefPool(pool);
    } catch {}
  };

  const availableRefs = refPool.filter(r => !usedRefs.includes(r));
  const addMoreRef = () => {
    const maxNum = refPool.length > 0 ? parseInt(refPool[refPool.length-1].replace('INIT-',''))||0 : 0;
    setRefPool([...refPool, `INIT-${String(maxNum+1).padStart(2,'0')}`]);
  };

  const openAdd = () => { setForm({title:'',description:'',impactStatement:'',keyResearchFocusAreas:'',reference:availableRefs[0]||''}); setSelectedSoIds([]); setModalFy(fy); setModal('add'); };
  const openEdit = (init) => { setForm({...init}); setSelectedSoIds((init.strategicObjectives||[]).map(s=>s.id)); setModalFy(fy); setModal('edit'); };
  const handleSave = async () => {
    if (!form.reference) { alert('Please select a reference number'); return; }
    try {
      const payload = {...form, strategicObjectiveIds: selectedSoIds};
      if (modal === 'add') await initiativesApi.create(payload);
      else await initiativesApi.update(form.id, payload);
      setModal(null); load();
    } catch(e) { alert('Error: ' + (e.response?.data?.error || e.message)); }
  };
  const handleDelete = async (id) => { if(window.confirm('Delete?')) { await initiativesApi.delete(id).catch(()=>{}); load(); }};
  const toggleSo = (soId) => setSelectedSoIds(prev => prev.includes(soId) ? prev.filter(x=>x!==soId) : [...prev, soId]);

  const [filterSo, setFilterSo] = useState('');
  const [modalFy, setModalFy] = useState(fy);
  const [modalObjectives, setModalObjectives] = useState([]);
  const filteredInit = filterSo ? initiatives.filter(i => (i.strategicObjectives||[]).some(s=>s.id===filterSo) || i.strategicObjectiveId===filterSo) : initiatives;

  // Load SOs for the FY selected in the modal form
  useEffect(() => { if (modal) { objectivesApi.getAll(modalFy).then(r => setModalObjectives(r.data||[])).catch(()=>{}); } }, [modalFy, modal]);

  return (
    <div>
      <div className="flex items-center justify-between mb-5">
        <div><p className="text-sm text-slate-500">{filteredInit.length} RDI & Industry Programmes</p><p className="text-[10px] text-slate-400 mt-0.5">Each programme links to one or more Strategic Objectives</p></div>
        <div className="flex items-center gap-2">
          <select className={input+' max-w-[130px]'} value={fy} onChange={e=>setFy(+e.target.value)}><option value={2025}>FY 24/25</option><option value={2026}>FY 25/26</option><option value={2027}>FY 26/27</option><option value={2028}>FY 27/28</option></select>
          <button onClick={openAdd} className={btnPrimary}><span className="text-lg leading-none">+</span> Add Programme</button>
        </div>
      </div>
      {/* SO Filter */}
      <div className="mb-4 flex items-center gap-2">
        <span className="text-xs text-slate-500">Filter by SO:</span>
        <select className={input+' max-w-[280px]'} value={filterSo} onChange={e=>setFilterSo(e.target.value)}>
          <option value="">All Strategic Objectives</option>
          {objectives.map(so => <option key={so.id} value={so.id}>{so.reference} — {so.title}</option>)}
        </select>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {filteredInit.map(init => (
          <div key={init.id} className="bg-white rounded-2xl border border-slate-200 border-l-4 border-l-[#c8102e] overflow-hidden hover:shadow-md transition-shadow">
            <div className="p-5">
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-2">
                  <span className="font-mono text-[10px] font-bold text-[#c8102e] bg-red-50 px-2 py-0.5 rounded">{init.reference}</span>
                  {(init.strategicObjectives||[]).map(so => <span key={so.id} className="text-[9px] bg-slate-100 text-slate-500 px-1.5 py-0.5 rounded font-semibold">{so.reference}</span>)}
                  {init.strategicObjective && !(init.strategicObjectives||[]).length && <span className="text-[9px] bg-slate-100 text-slate-500 px-1.5 py-0.5 rounded font-semibold">{init.strategicObjective.reference}</span>}
                </div>
                <div className="flex gap-1"><button onClick={()=>openEdit(init)} className="text-xs text-slate-400 hover:text-slate-600">✏️</button><button onClick={()=>handleDelete(init.id)} className="text-xs text-red-400 hover:text-red-600">🗑️</button></div>
              </div>
              <h4 className="text-base font-bold text-slate-800 mb-3">{init.title}</h4>
              {init.description && (<div className="mb-3"><p className="text-[10px] font-bold text-[#c8102e] uppercase tracking-wider mb-1">Research Objective</p><p className="text-xs text-slate-600 leading-relaxed">{init.description}</p></div>)}
              {init.impactStatement && (<div className="mb-3"><p className="text-[10px] font-bold text-[#c8102e] uppercase tracking-wider mb-1">Impact Statement</p><p className="text-xs text-slate-600 leading-relaxed">{init.impactStatement}</p></div>)}
              {init.keyResearchFocusAreas && (<div><p className="text-[10px] font-bold text-[#c8102e] uppercase tracking-wider mb-1">Key Research Focus Areas</p><ul className="text-xs text-slate-600 leading-relaxed space-y-1">{init.keyResearchFocusAreas.split('\n').filter(Boolean).map((line,i) => <li key={i} className="flex items-start gap-1.5"><span className="text-[#c8102e] mt-0.5 text-[8px]">●</span><span>{line.replace(/^[-•*]\s*/,'')}</span></li>)}</ul></div>)}
            </div>
          </div>
        ))}
      </div>
      <Modal open={!!modal} onClose={()=>setModal(null)} title={modal==='add' ? 'Add RDI & Industry Programme' : 'Edit RDI & Industry Programme'}>
        <div className="space-y-4">
          <Field label="Reference Number" required>
            <div className="flex gap-2">
              <select className={input+' flex-1'} value={form.reference||''} onChange={e=>setForm({...form,reference:e.target.value})}>
                <option value="">— Select Reference —</option>
                {modal==='edit' && form.reference && <option value={form.reference}>{form.reference} (current)</option>}
                {availableRefs.map(r => <option key={r} value={r}>{r}</option>)}
              </select>
              <button type="button" onClick={addMoreRef} className="px-3 py-2 bg-slate-100 hover:bg-slate-200 rounded-xl text-sm font-bold text-slate-600 whitespace-nowrap">+ Add</button>
            </div>
          </Field>
          <Field label="Programme Title" required><input className={input} value={form.title||''} onChange={e=>setForm({...form,title:e.target.value})} /></Field>
          <Field label="Research Programme Objective"><textarea className={input} rows={3} value={form.description||''} onChange={e=>setForm({...form,description:e.target.value})} /></Field>
          <Field label="Impact Statement"><textarea className={input} rows={2} value={form.impactStatement||''} onChange={e=>setForm({...form,impactStatement:e.target.value})} placeholder="Describe the expected impact of this programme" /></Field>
          <Field label="Key Research Focus Areas"><textarea className={input} rows={2} value={form.keyResearchFocusAreas||''} onChange={e=>setForm({...form,keyResearchFocusAreas:e.target.value})} placeholder="List the key focus areas" /></Field>
          <Field label="Financial Year" required hint="Strategic Objectives below will filter by this FY">
            <select className={input} value={modalFy} onChange={e=>{setModalFy(+e.target.value);setSelectedSoIds([]);}}>
              <option value={2025}>FY 24/25</option><option value={2026}>FY 25/26</option><option value={2027}>FY 26/27</option><option value={2028}>FY 27/28</option>
            </select>
          </Field>
          <Field label="Link to Strategic Objectives" required hint={`Showing ${modalObjectives.length} objectives for FY ${modalFy-1}/${modalFy%100}`}>
            <div className="space-y-1 max-h-40 overflow-y-auto border rounded-xl p-2">
              {modalObjectives.length > 0 ? modalObjectives.map(so => (<label key={so.id} className="flex items-center gap-2 p-1.5 rounded-lg hover:bg-slate-50 cursor-pointer"><input type="checkbox" checked={selectedSoIds.includes(so.id)} onChange={()=>toggleSo(so.id)} className="rounded border-slate-300" /><span className="font-mono text-[10px] text-[#c8102e]">{so.reference}</span><span className="text-sm text-slate-700">{so.title}</span></label>))
              : <p className="text-xs text-slate-400 py-2 text-center">No strategic objectives for this FY</p>}
            </div>
          </Field>
          <p className="text-[10px] text-slate-400 italic">{availableRefs.length} references available · Click "+ Add" to create more</p>
          <div className="flex justify-end gap-2 pt-2"><button onClick={()=>setModal(null)} className={btnSecondary}>Cancel</button><button onClick={handleSave} className={btnPrimary}>💾 {modal==='add' ? 'Create' : 'Save'}</button></div>
        </div>
      </Modal>
    </div>
  );
}

// ════════════════════════════════════════
// TAB 3: TECHNICAL CLUSTERS
// ════════════════════════════════════════
function TechnicalClustersTab() {
  const [clusters, setClusters] = useState([]);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({});

  useEffect(() => { load(); }, []);
  const load = () => clustersApi.getAll().then(r => { setClusters((r.data||[]).filter(c => c.code !== 'SUP' && c.code !== 'RDI-OPS')); }).catch(()=>{});

  const openAddDiv = (clusterId) => { setForm({name:'',code:'',description:'',clusterId}); setModal('add'); };
  const openEditDiv = (d) => { setForm({...d}); setModal('edit'); };
  const handleSave = async () => { try { if (modal === 'add') await divisionsApi.create(form); else await divisionsApi.update(form.id, form); setModal(null); load(); } catch(e) { alert('Error: ' + (e.response?.data?.error||e.message)); } };
  const handleDeleteDiv = async (id) => { if(window.confirm('Remove division?')) { try { await divisionsApi.delete(id); load(); } catch(e) { alert('Error deleting: ' + (e.response?.data?.error||e.message)); } } };

  const clusterColors = { 0: {border:'border-l-[#c8102e]', bg:'bg-red-50', accent:'text-[#c8102e]'}, 1: {border:'border-l-blue-600', bg:'bg-blue-50', accent:'text-blue-600'}, 2: {border:'border-l-amber-600', bg:'bg-amber-50', accent:'text-amber-600'} };
  return (
    <div>
      <p className="text-sm text-slate-500 mb-5">Mintek's Technical Clusters, each comprising specialised research divisions</p>
      <div className="space-y-6">
        {clusters.map((cluster, ci) => { const colors = clusterColors[ci % 3]; return (
            <div key={cluster.id} className="cluster-section-design">
              <div className="cluster-section-head"><div><h3 className="cluster-title-red">{cluster.name}</h3><p className="cluster-desc">{cluster.description}</p></div><button onClick={() => openAddDiv(cluster.id)} className={btnPrimary}><span className="text-lg leading-none">+</span> Add Division</button></div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                {(cluster.divisions||[]).map(div => (
                  <div key={div.id} className="tech-division-card group">
                    <div className="tech-icon-wrap">⚗️</div>
                    <div className="division-actions"><button onClick={()=>openEditDiv(div)} className="text-[10px] text-slate-400 hover:text-slate-600">✏️</button><button onClick={()=>handleDeleteDiv(div.id)} className="text-[10px] text-red-400 hover:text-red-600">🗑️</button></div>
                    <h4 className="text-sm font-bold text-slate-900 mb-1">{div.name}</h4><p className="text-[10px] text-slate-700 leading-tight line-clamp-2">{div.description}</p>{div.code && <span className="inline-block mt-2 text-[9px] font-mono font-bold text-slate-500 bg-slate-100 px-1.5 py-0.5 rounded">{div.code}</span>}
                  </div>
                ))}
              </div>
            </div>
        ); })}
      </div>
      <Modal open={!!modal} onClose={()=>setModal(null)} title={`${modal==='add'?'Add':'Edit'} Division`}>
        <div className="space-y-4">
          <Field label="Division Name"><input className={input} value={form.name||''} onChange={e=>setForm({...form,name:e.target.value})} /></Field>
          <div className="grid grid-cols-2 gap-3"><Field label="Code"><input className={input} value={form.code||''} onChange={e=>setForm({...form,code:e.target.value})} placeholder="e.g. HMS" /></Field></div>
          <Field label="Description"><textarea className={input} rows={3} value={form.description||''} onChange={e=>setForm({...form,description:e.target.value})} /></Field>
          <div className="flex justify-end gap-2 pt-2"><button onClick={()=>setModal(null)} className={btnSecondary}>Cancel</button><button onClick={handleSave} className={btnPrimary}>💾 Save</button></div>
        </div>
      </Modal>
    </div>
  );
}

// ════════════════════════════════════════
// TAB 4: SUPPORT SERVICES CLUSTER
// ════════════════════════════════════════
function SupportServicesTab() {
  const [cluster, setCluster] = useState(null);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({});
  useEffect(() => { load(); }, []);
  const load = () => clustersApi.getAll().then(r => { setCluster((r.data||[]).find(c => c.code === 'SUP' || c.name?.toLowerCase().includes('support') || c.name?.toLowerCase().includes('corporate')) || null); }).catch(()=>{});
  const openAddDiv = () => { if(!cluster) return; setForm({name:'',code:'',description:'',clusterId:cluster.id}); setModal('add'); };
  const openEditDiv = (d) => { setForm({...d}); setModal('edit'); };
  const handleSave = async () => { try { if (modal === 'add') await divisionsApi.create(form); else await divisionsApi.update(form.id, form); setModal(null); load(); } catch(e) { alert('Error'); } };
  const handleDeleteDiv = async (id) => { if(window.confirm('Remove?')) { try { await divisionsApi.delete(id); load(); } catch(e) { alert('Error deleting: ' + (e.response?.data?.error||e.message)); } } };
  const divisions = (cluster?.divisions || []).filter(d => d.code !== 'RDI-OPS');
  const supportIcons = {'HR':'👥','Finance':'💰','FIN':'💰','ICT':'💻','Engineering':'⚙️','SHEQ':'🛡️','Legal':'⚖️','CMS':'📋','Supply Chain':'📦'};
  return (
    <div>
      <div className="flex items-center justify-between mb-4"><div><p className="text-lg text-slate-600">Support Services Cluster</p><p className="text-sm text-slate-600 mt-0.5">HR, Finance, Engineering and other enabling functions</p></div><button onClick={openAddDiv} className={btnPrimary}><span className="text-lg leading-none">+</span> Add Division</button></div>
      <div className="support-area-design grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {divisions.map(div => { const icon = Object.entries(supportIcons).find(([k]) => div.name?.includes(k) || div.code?.includes(k))?.[1] || '🏢'; return (
            <div key={div.id} className="support-division-card group"><div className="support-icon-box">{icon}</div><div className="min-w-0"><h4 className="text-lg font-bold text-slate-900 mb-2">{div.name}</h4><p className="text-sm text-slate-600 leading-snug line-clamp-2">{div.description}</p></div><div className="absolute right-4 top-4 flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity"><button onClick={()=>openEditDiv(div)} className="text-xs text-slate-400">✏️</button><button onClick={()=>handleDeleteDiv(div.id)} className="text-xs text-red-400">🗑️</button></div></div>
        ); })}
        {divisions.length === 0 && <div className="col-span-full text-center py-12 text-slate-400 text-sm">No support divisions found.</div>}
      </div>
      <Modal open={!!modal} onClose={()=>setModal(null)} title={`${modal==='add'?'Add':'Edit'} Support Division`}>
        <div className="space-y-4">
          <Field label="Division Name"><input className={input} value={form.name||''} onChange={e=>setForm({...form,name:e.target.value})} placeholder="e.g. Human Resources" /></Field>
          <Field label="Code"><input className={input} value={form.code||''} onChange={e=>setForm({...form,code:e.target.value})} placeholder="e.g. HR" /></Field>
          <Field label="Description"><textarea className={input} rows={2} value={form.description||''} onChange={e=>setForm({...form,description:e.target.value})} /></Field>
          <div className="flex justify-end gap-2 pt-2"><button onClick={()=>setModal(null)} className={btnSecondary}>Cancel</button><button onClick={handleSave} className={btnPrimary}>💾 Save</button></div>
        </div>
      </Modal>
    </div>
  );
}

// ════════════════════════════════════════
// TAB 5: RDI OPERATIONAL SERVICES
// ════════════════════════════════════════
function RdiOperationalServicesTab() {
  const [cluster, setCluster] = useState(null);
  const [divisions, setDivisions] = useState([]);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({});
  const [seeded, setSeeded] = useState(false);

  useEffect(() => { load(); }, []);
  const load = async () => {
    try {
      const r = await clustersApi.getAll();
      let found = (r.data||[]).find(c => c.code === 'RDI-OPS' || c.name?.toLowerCase().includes('rdi operational'));
      
      // If cluster doesn't exist, create it and seed defaults
      if (!found && !seeded) {
        setSeeded(true);
        try {
          const createRes = await clustersApi.create({ name: 'RDI Operational Services', code: 'RDI-OPS', description: 'A standalone division responsible for cross-cutting RDI support functions' });
          found = createRes.data;
          await seedDefaults(found.id);
          // Reload to get divisions
          const r2 = await clustersApi.getAll();
          found = (r2.data||[]).find(c => c.id === found.id);
        } catch {}
      }
      
      // If cluster exists but empty, seed defaults
      if (found && (found.divisions||[]).length === 0 && !seeded) {
        setSeeded(true);
        await seedDefaults(found.id);
        const r2 = await clustersApi.getAll();
        found = (r2.data||[]).find(c => c.id === found.id);
      }
      
      setCluster(found || null);
      setDivisions(found?.divisions || []);
    } catch {}
  };

  const seedDefaults = async (clusterId) => {
    const defaults = [
      {name:'Planning, Monitoring, Evaluation, and Reporting (PMER)', code:'PMER'},
      {name:'R&D Management', code:'RDM'},
      {name:'Business Development and Commercialisation', code:'BDC'},
      {name:'Communications', code:'COMMS'},
      {name:'Safety, Health, Environment and Quality (SHEQ), and Enterprise Risk Management (ERM)', code:'SHEQ-ERM'}
    ];
    for (const d of defaults) {
      try { await divisionsApi.create({...d, clusterId, description: 'RDI Operational Services function'}); } catch {}
    }
    load();
  };

  const ensureCluster = async () => {
    if (cluster) return cluster.id;
    const res = await clustersApi.create({ name: 'RDI Operational Services', code: 'RDI-OPS', description: 'A standalone division responsible for cross-cutting RDI support functions' });
    setCluster(res.data);
    return res.data.id;
  };

  const openAdd = () => { setForm({name:'',code:'',description:''}); setModal('add'); };
  const openEdit = (d) => { setForm({...d}); setModal('edit'); };
  const handleSave = async () => {
    try {
      if (modal === 'add') {
        const clusterId = await ensureCluster();
        await divisionsApi.create({...form, clusterId});
      } else {
        await divisionsApi.update(form.id, form);
      }
      setModal(null); load();
    } catch(e) { alert('Error: ' + (e.response?.data?.error||e.message)); }
  };
  const handleDelete = async (id) => { if(window.confirm('Delete this function?')) { try { await divisionsApi.delete(id); load(); } catch(e) { alert('Error: ' + (e.response?.data?.error||e.message)); } } };

  const icons = {'PMER':'📊','R&D':'🔬','Business':'💼','Commerc':'💼','Communic':'📡','SHEQ':'🛡️','ERM':'🛡️','Safety':'🛡️'};
  const getIcon = (name) => Object.entries(icons).find(([k]) => name?.includes(k))?.[1] || '🏢';

  return (
    <div>
      <div className="flex items-center justify-between mb-5">
        <div><p className="text-sm text-slate-500">RDI Operational Services ({divisions.length} functions)</p><p className="text-[10px] text-slate-400 mt-0.5">A standalone division responsible for cross-cutting RDI support functions</p></div>
        <button onClick={openAdd} className={btnPrimary}><span className="text-lg leading-none">+</span> Add Function</button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {divisions.map(div => (
          <div key={div.id} className="bg-white rounded-xl border border-slate-200 p-5 hover:shadow-sm transition-shadow group">
            <div className="flex items-center justify-between mb-3">
              <div className="w-10 h-10 rounded-xl bg-purple-50 flex items-center justify-center text-xl">{getIcon(div.name)}</div>
              <div className="flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity"><button onClick={()=>openEdit(div)} className="text-xs text-slate-400 hover:text-slate-600">✏️</button><button onClick={()=>handleDelete(div.id)} className="text-xs text-red-400 hover:text-red-600">🗑️</button></div>
            </div>
            <h4 className="text-sm font-bold text-slate-800 mb-1">{div.name}</h4>
            <p className="text-[10px] text-slate-400">{div.description || 'RDI Operational Services function'}</p>
            {div.code && <span className="inline-block mt-2 text-[9px] font-mono font-bold text-slate-400 bg-slate-100 px-1.5 py-0.5 rounded">{div.code}</span>}
          </div>
        ))}
        {divisions.length === 0 && <div className="col-span-full text-center py-12 text-slate-400 text-sm">{seeded ? 'No functions found. Click "+ Add Function" to create one.' : 'Setting up RDI functions...'}</div>}
      </div>
      <div className="mt-6 bg-purple-50 rounded-2xl border border-purple-200 p-5"><p className="text-xs text-purple-700">RDI Operational Services operates as its own division, separate from the Support Services Cluster.</p></div>
      <Modal open={!!modal} onClose={()=>setModal(null)} title={`${modal==='add'?'Add':'Edit'} RDI Function`}>
        <div className="space-y-4">
          <Field label="Function Name" required><input className={input} value={form.name||''} onChange={e=>setForm({...form,name:e.target.value})} placeholder="e.g. Planning, Monitoring, Evaluation, and Reporting (PMER)" /></Field>
          <Field label="Code"><input className={input} value={form.code||''} onChange={e=>setForm({...form,code:e.target.value})} placeholder="e.g. PMER" /></Field>
          <Field label="Description"><textarea className={input} rows={2} value={form.description||''} onChange={e=>setForm({...form,description:e.target.value})} /></Field>
          <div className="flex justify-end gap-2 pt-2"><button onClick={()=>setModal(null)} className={btnSecondary}>Cancel</button><button onClick={handleSave} className={btnPrimary}>💾 Save</button></div>
        </div>
      </Modal>
    </div>
  );
}

// ════════════════════════════════════════
// TAB 6: KPI DEFINITIONS
// ════════════════════════════════════════
function KpiDefinitionsTab() {
  const [kpis, setKpis] = useState([]);
  const [objectives, setObjectives] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({});
  const [filterSo, setFilterSo] = useState('');
  const [filterDiv, setFilterDiv] = useState('');
  const [refPool, setRefPool] = useState([]);
  const [usedRefs, setUsedRefs] = useState([]);
  const [fy, setFy] = useState(2026);

  useEffect(() => { load(); }, [fy]);
  const load = async () => {
    try {
      const [kpiRes, soRes, divRes, usedRes] = await Promise.all([kpisApi.getAll({financialYear:fy}), objectivesApi.getAll(fy), divisionsApi.getAll(), kpisApi.getUsedReferences()]);
      setKpis(kpiRes.data||[]); setObjectives(soRes.data||[]); setDivisions(divRes.data||[]);
      const taken = usedRes.data || [];
      setUsedRefs(taken);
      const maxNum = Math.max(...taken.map(r => parseInt(r?.replace('KPI-APP-',''))||0), (kpiRes.data||[]).length, 4);
      const pool = [];
      for (let i = 1; i <= maxNum + 3; i++) pool.push(`KPI-APP-${String(i).padStart(2,'0')}`);
      setRefPool(pool);
    } catch {}
  };

  const availableRefs = refPool.filter(r => !usedRefs.includes(r));
  const addMoreRef = () => {
    const maxNum = refPool.length > 0 ? parseInt(refPool[refPool.length-1].replace('KPI-APP-',''))||0 : 0;
    setRefPool([...refPool, `KPI-APP-${String(maxNum+1).padStart(2,'0')}`]);
  };

  const openAdd = () => { setForm({name:'',type:'Quantitative',frequency:'Quarterly',unit:'',unitFunction:'',financialYear:fy,isAppIndicator:true,strategicObjectiveId:'',divisionId:'',methodOfCalculation:'',dataSource:'',responsibleOwner:'',baseline:'',reference:availableRefs[0]||''}); setModal('add'); };
  const openEdit = (k) => { setForm({...k, strategicObjectiveId:k.strategicObjectiveId||k.strategicObjective?.id||'', divisionId:k.divisionId||k.division?.id||'', unitFunction:k.unitFunction||''}); setModal('edit'); };

  const handleSave = async () => {
    // Validate compulsory fields
    if (!form.reference) { alert('Please select a reference number'); return; }
    if (!form.strategicObjectiveId) { alert('Strategic Objective is required'); return; }
    if (!form.unit) { alert('Unit is required'); return; }
    if (!form.unitFunction) { alert('Unit Function is required'); return; }
    if (form.frequency === 'Quarterly') {
      if (!form.q1Target && !form.q2Target && !form.q3Target && !form.q4Target && form.type === 'Quantitative' && !form.qualitativeQ1Target && !form.qualitativeQ2Target && !form.qualitativeQ3Target && !form.qualitativeQ4Target) { alert('For quarterly KPIs, at least one quarter target is required'); return; }
    }
    try {
      const payload = {...form};
      if (!payload.divisionId) delete payload.divisionId;
      // Clean up type-specific fields to avoid deserialization errors
      if (payload.type === 'Qualitative') {
        payload.annualTarget = null; payload.q1Target = null; payload.q2Target = null; payload.q3Target = null; payload.q4Target = null;
      } else {
        payload.qualitativeAnnualTarget = null; payload.qualitativeQ1Target = null; payload.qualitativeQ2Target = null; payload.qualitativeQ3Target = null; payload.qualitativeQ4Target = null;
      }
      // Convert empty strings to null for numeric fields
      ['annualTarget','q1Target','q2Target','q3Target','q4Target','baseline'].forEach(k => { if (payload[k] === '' || payload[k] === undefined) payload[k] = null; });
      if (modal === 'add') await kpisApi.create(payload);
      else await kpisApi.update(form.id, payload);
      setModal(null); load();
    } catch(e) { alert('Error: ' + (e.response?.data?.error || e.message)); }
  };
  const handleDelete = async (id) => { if(window.confirm('Delete?')) { await kpisApi.delete(id).catch(()=>{}); load(); }};

  // Auto-sum when unit function is Sum and frequency is Quarterly
  const updateTarget = (field, value) => {
    const updated = {...form, [field]: value};
    if (updated.unitFunction === 'Sum' && updated.frequency === 'Quarterly' && updated.type === 'Quantitative') {
      updated.annualTarget = (parseFloat(updated.q1Target)||0) + (parseFloat(updated.q2Target)||0) + (parseFloat(updated.q3Target)||0) + (parseFloat(updated.q4Target)||0);
    }
    setForm(updated);
  };

  const isQualitative = form.type === 'Qualitative';
  const isAnnual = form.frequency === 'Annually';
  const filteredKpis = kpis.filter(k => {
    if (filterSo && k.strategicObjectiveId !== filterSo) return false;
    return true;
  });

  return (
    <div>
      <div className="flex items-center justify-between mb-5">
        <div><p className="text-sm text-slate-500">{filteredKpis.length} KPI definitions for FY {fy-1}/{fy%100}</p><p className="text-[10px] text-slate-400 mt-0.5">All KPIs are APP indicators. SO linkage, Unit, and Unit Function are compulsory.</p></div>
        <div className="flex items-center gap-2">
          <select className={input+' max-w-[130px]'} value={fy} onChange={e=>setFy(+e.target.value)}><option value={2025}>FY 24/25</option><option value={2026}>FY 25/26</option><option value={2027}>FY 26/27</option><option value={2028}>FY 27/28</option></select>
          <button onClick={openAdd} className={btnPrimary}><span className="text-lg leading-none">+</span> Add KPI</button>
        </div>
      </div>

      {/* Filters */}
      <div className="mb-3 flex items-center gap-3 flex-wrap">
        <span className="text-xs text-slate-500">Filter:</span>
        <select className={input+' max-w-[250px]'} value={filterSo} onChange={e=>setFilterSo(e.target.value)}>
          <option value="">All Strategic Objectives</option>
          {objectives.map(so => <option key={so.id} value={so.id}>{so.reference} — {so.title}</option>)}
        </select>
        {filterSo&&<button onClick={()=>{setFilterSo('');}} className="text-xs text-[#c8102e] font-semibold hover:underline">Clear</button>}
      </div>

      <div className="bg-white rounded-xl border border-slate-200 overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="bg-slate-50/80">
            <th className="px-3 py-3 text-left text-[10px] font-bold text-slate-500 uppercase">Ref</th>
            <th className="px-3 py-3 text-left text-[10px] font-bold text-slate-500 uppercase">KPI Measure</th>
            <th className="px-3 py-3 text-left text-[10px] font-bold text-slate-500 uppercase">SO</th>
            <th className="px-3 py-3 text-center text-[10px] font-bold text-slate-500 uppercase">Unit</th>
            <th className="px-3 py-3 text-center text-[10px] font-bold text-slate-500 uppercase">Unit Fn</th>
            <th className="px-3 py-3 text-center text-[10px] font-bold text-slate-500 uppercase">Reporting Cycle</th>
            <th className="px-3 py-3 text-right text-[10px] font-bold text-slate-500 uppercase">Annual</th>
            <th className="px-3 py-3 text-right text-[10px] font-bold text-slate-500 uppercase">Q1</th>
            <th className="px-3 py-3 text-right text-[10px] font-bold text-slate-500 uppercase">Q2</th>
            <th className="px-3 py-3 text-right text-[10px] font-bold text-slate-500 uppercase">Q3</th>
            <th className="px-3 py-3 text-right text-[10px] font-bold text-slate-500 uppercase">Q4</th>
            <th className="px-3 py-3"></th>
          </tr></thead>
          <tbody>{filteredKpis.map(k => (
            <tr key={k.id} className="border-t border-slate-100 hover:bg-slate-50/50">
              <td className="px-3 py-3"><span className="font-mono text-xs font-bold text-[#c8102e]">{k.reference}</span></td>
              <td className="px-3 py-3 text-sm text-slate-700 max-w-[180px] truncate">{k.name}</td>
              <td className="px-3 py-3 text-[10px] text-slate-400">{k.strategicObjective?.reference || '—'}</td>
              <td className="px-3 py-3 text-center text-[10px]"><span className="bg-blue-50 text-blue-700 px-1.5 py-0.5 rounded font-semibold">{k.unit||'—'}</span></td>
              <td className="px-3 py-3 text-center text-[10px]"><span className="bg-slate-100 text-slate-600 px-1.5 py-0.5 rounded">{UNIT_FUNCTION_LABELS[k.unitFunction]||'—'}</span></td>
              <td className="px-3 py-3 text-center text-[10px] text-slate-500">{k.frequency}</td>
              <td className="px-3 py-3 text-right font-mono text-xs font-bold">{k.type==='Qualitative'?(k.qualitativeAnnualTarget||'—'):k.annualTarget??'—'}</td>
              <td className="px-3 py-3 text-right font-mono text-xs">{k.type==='Qualitative'?(k.qualitativeQ1Target||'—'):k.q1Target??'—'}</td>
              <td className="px-3 py-3 text-right font-mono text-xs">{k.type==='Qualitative'?(k.qualitativeQ2Target||'—'):k.q2Target??'—'}</td>
              <td className="px-3 py-3 text-right font-mono text-xs">{k.type==='Qualitative'?(k.qualitativeQ3Target||'—'):k.q3Target??'—'}</td>
              <td className="px-3 py-3 text-right font-mono text-xs">{k.type==='Qualitative'?(k.qualitativeQ4Target||'—'):k.q4Target??'—'}</td>
              <td className="px-3 py-3 text-right"><button onClick={()=>openEdit(k)} className="text-xs text-slate-400 hover:text-slate-600 mr-1">✏️</button><button onClick={()=>handleDelete(k.id)} className="text-xs text-red-400 hover:text-red-600">🗑️</button></td>
            </tr>
          ))}</tbody>
        </table>
      </div>

      <Modal open={!!modal} onClose={()=>setModal(null)} title={modal==='add' ? 'Add KPI Definition' : 'Edit KPI Definition'} wide>
        <div className="space-y-4">
          <Field label="Reference Number" required>
            <div className="flex gap-2">
              <select className={input+' flex-1'} value={form.reference||''} onChange={e=>setForm({...form,reference:e.target.value})}>
                <option value="">— Select Reference —</option>
                {modal==='edit' && form.reference && <option value={form.reference}>{form.reference} (current)</option>}
                {availableRefs.map(r => <option key={r} value={r}>{r}</option>)}
              </select>
              <button type="button" onClick={addMoreRef} className="px-3 py-2 bg-slate-100 hover:bg-slate-200 rounded-xl text-sm font-bold text-slate-600 whitespace-nowrap">+ Add</button>
            </div>
          </Field>
          <Field label="KPI Name" required><input className={input} value={form.name||''} onChange={e=>setForm({...form,name:e.target.value})} placeholder="e.g. Number of peer-reviewed publications" /></Field>
          <Field label="Description"><textarea className={input} rows={2} value={form.description||''} onChange={e=>setForm({...form,description:e.target.value})} /></Field>
            <Field label="Link to Strategic Objective" required>
              <select className={input} value={form.strategicObjectiveId||''} onChange={e=>setForm({...form,strategicObjectiveId:e.target.value})}><option value="">— Select Objective —</option>{objectives.map(so => <option key={so.id} value={so.id}>{so.reference} — {so.title}</option>)}</select>
            </Field>
          <div className="grid grid-cols-5 gap-3">
            <Field label="Financial Year" required><select className={input} value={form.financialYear||fy} onChange={e=>setForm({...form,financialYear:+e.target.value})}><option value={2025}>FY 24/25</option><option value={2026}>FY 25/26</option><option value={2027}>FY 26/27</option><option value={2028}>FY 27/28</option></select></Field>
            <Field label="Type"><select className={input} value={form.type||'Quantitative'} onChange={e=>setForm({...form,type:e.target.value})}><option>Quantitative</option><option>Qualitative</option></select></Field>
            <Field label="Reporting Cycle"><select className={input} value={form.frequency||'Quarterly'} onChange={e=>setForm({...form,frequency:e.target.value})}><option>Quarterly</option><option>Annually</option></select></Field>
            <Field label="Unit" required><select className={input} value={form.unit||''} onChange={e=>setForm({...form,unit:e.target.value})}><option value="">— Select —</option>{UNITS.map(u=><option key={u}>{u}</option>)}</select></Field>
            <Field label="Unit Function" required><select className={input} value={form.unitFunction||''} onChange={e=>setForm({...form,unitFunction:e.target.value})}><option value="">— Select —</option>{UNIT_FUNCTIONS.map(u=><option key={u} value={u}>{UNIT_FUNCTION_LABELS[u]}</option>)}</select></Field>
          </div>
          <div className="bg-slate-50 rounded-xl p-4"><p className="text-xs font-semibold text-slate-500 uppercase mb-3">Targets {form.unitFunction==='Sum'&&form.frequency==='Quarterly'&&!isQualitative?'(Annual auto-calculated from quarters)':''}</p>
            {isQualitative ? (
              <div className="grid grid-cols-5 gap-2">
                <Field label="Annual"><input className={input} value={form.qualitativeAnnualTarget||''} onChange={e=>setForm({...form,qualitativeAnnualTarget:e.target.value})} placeholder="e.g. Unqualified Audit" /></Field>
                <Field label="Q1"><input className={input} value={form.qualitativeQ1Target||''} onChange={e=>setForm({...form,qualitativeQ1Target:e.target.value})} disabled={isAnnual} /></Field>
                <Field label="Q2"><input className={input} value={form.qualitativeQ2Target||''} onChange={e=>setForm({...form,qualitativeQ2Target:e.target.value})} disabled={isAnnual} /></Field>
                <Field label="Q3"><input className={input} value={form.qualitativeQ3Target||''} onChange={e=>setForm({...form,qualitativeQ3Target:e.target.value})} disabled={isAnnual} /></Field>
                <Field label="Q4"><input className={input} value={form.qualitativeQ4Target||''} onChange={e=>setForm({...form,qualitativeQ4Target:e.target.value})} /></Field>
              </div>
            ) : (
              <div className="grid grid-cols-5 gap-2">
                <Field label="Annual"><input type="number" step="0.01" className={input} value={form.annualTarget||''} onChange={e=>updateTarget('annualTarget',e.target.value)} readOnly={form.unitFunction==='Sum'&&form.frequency==='Quarterly'} /></Field>
                <Field label="Q1"><input type="number" step="0.01" className={input} value={form.q1Target||''} onChange={e=>updateTarget('q1Target',e.target.value)} disabled={isAnnual} /></Field>
                <Field label="Q2"><input type="number" step="0.01" className={input} value={form.q2Target||''} onChange={e=>updateTarget('q2Target',e.target.value)} disabled={isAnnual} /></Field>
                <Field label="Q3"><input type="number" step="0.01" className={input} value={form.q3Target||''} onChange={e=>updateTarget('q3Target',e.target.value)} disabled={isAnnual} /></Field>
                <Field label="Q4"><input type="number" step="0.01" className={input} value={form.q4Target||''} onChange={e=>updateTarget('q4Target',e.target.value)} /></Field>
              </div>
            )}
            {isAnnual && !isQualitative && <p className="text-[10px] text-amber-600 mt-2">Annual measure: quarterly target should be entered in Q4. Actuals can be captured in all quarters.</p>}
          </div>
          <div className="grid grid-cols-2 gap-3">
            <Field label="Desired Performance / Baseline"><input className={input} type="number" step="0.01" value={form.baseline||''} onChange={e=>setForm({...form,baseline:e.target.value})} /></Field>
            <Field label="Responsible Owner"><select className={input} value={form.responsibleOwner||''} onChange={e=>setForm({...form,responsibleOwner:e.target.value})}><option value="">— Select —</option>{RESPONSIBLE_OWNERS.map(o=><option key={o}>{o}</option>)}</select></Field>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <Field label="Source / Collection of Data"><input className={input} value={form.dataSource||''} onChange={e=>setForm({...form,dataSource:e.target.value})} placeholder="e.g. IFS, SharePoint, Manual" /></Field>
            <Field label="Method of Calculation / Assessment"><input className={input} value={form.methodOfCalculation||''} onChange={e=>setForm({...form,methodOfCalculation:e.target.value})} placeholder="e.g. Sum of quarterly outputs" /></Field>
          </div>
          <p className="text-[10px] text-slate-400 italic">{availableRefs.length} references available · Click "+ Add" to create more</p>
          <div className="flex justify-end gap-2 pt-2"><button onClick={()=>setModal(null)} className={btnSecondary}>Cancel</button><button onClick={handleSave} className={btnPrimary}>💾 {modal==='add' ? 'Create' : 'Save'}</button></div>
        </div>
      </Modal>
    </div>
  );
}

// ════════════════════════════════════════
// TAB 7: RISK TAXONOMY
// ════════════════════════════════════════
function TaxonomyTab() {
  const [items, setItems] = useState([]);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({});
  useEffect(() => { load(); }, []);
  const load = () => risksApi.getTaxonomy().then(r => setItems(r.data)).catch(() => {});
  const openAdd = (parentId) => { setForm({name:'',code:'',description:'',parentId:parentId||null,sortOrder:0}); setModal('add'); };
  const openEdit = (item) => { setForm({...item}); setModal('edit'); };
  const handleSave = async () => { try { if(modal==='add') await risksApi.addTaxonomy(form); else await risksApi.updateTaxonomy(form.id,form); setModal(null); load(); } catch {} };
  const handleDelete = async (id) => { if(window.confirm('Delete?')) { await risksApi.deleteTaxonomy(id).catch(()=>{}); load(); }};
  const renderItem = (item, depth=0) => (
    <div key={item.id} className="border-b border-slate-100 last:border-0">
      <div className="flex items-center gap-2 p-3 hover:bg-slate-50/50" style={{paddingLeft:`${depth*24+16}px`}}>
        <span className="text-sm text-[#c8102e]">🛡️</span><span className="font-mono text-[10px] text-slate-400 bg-slate-100 px-1.5 py-0.5 rounded">{item.code}</span><span className="flex-1 text-sm text-slate-700">{item.name}</span>
        <button onClick={()=>openAdd(item.id)} className="text-[10px] text-[#c8102e] font-semibold hover:underline">+ Sub</button><button onClick={()=>openEdit(item)} className="text-xs text-slate-400">✏️</button><button onClick={()=>handleDelete(item.id)} className="text-xs text-red-400">🗑️</button>
      </div>
      {item.children?.map(child => renderItem(child, depth+1))}
    </div>
  );
  return (
    <div>
      <div className="flex items-center justify-between mb-5"><p className="text-sm text-slate-500">Enterprise risk category taxonomy</p><button onClick={()=>openAdd(null)} className={btnPrimary}><span className="text-lg leading-none">+</span> Add Root Category</button></div>
      <div className="bg-white rounded-xl border border-slate-200">{items.map(item => renderItem(item))}</div>
      <Modal open={!!modal} onClose={()=>setModal(null)} title={`${modal==='add'?'Add':'Edit'} Taxonomy Item`}>
        <div className="space-y-4">
          <Field label="Name"><input className={input} value={form.name||''} onChange={e=>setForm({...form,name:e.target.value})} /></Field>
          <div className="grid grid-cols-2 gap-3"><Field label="Code"><input className={input} value={form.code||''} onChange={e=>setForm({...form,code:e.target.value})} /></Field><Field label="Sort Order"><input type="number" className={input} value={form.sortOrder||0} onChange={e=>setForm({...form,sortOrder:+e.target.value})} /></Field></div>
          <Field label="Description"><textarea className={input} rows={2} value={form.description||''} onChange={e=>setForm({...form,description:e.target.value})} /></Field>
          <div className="flex justify-end gap-2 pt-2"><button onClick={()=>setModal(null)} className={btnSecondary}>Cancel</button><button onClick={handleSave} className={btnPrimary}>💾 Save</button></div>
        </div>
      </Modal>
    </div>
  );
}

// ════════════════════════════════════════
// TAB 8: FINANCIAL YEARS
// ════════════════════════════════════════
function FinancialYearsTab() {
  const [years, setYears] = useState([]);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({});
  useEffect(() => { load(); }, []);
  const load = () => financialYearsApi.getAll().then(r => setYears(r.data || [])).catch(() => {});
  const fmtDate = d => d ? new Date(d).toLocaleDateString('en-ZA', {day:'numeric',month:'short',year:'numeric'}) : '—';
  const openAdd = () => { const yr = new Date().getFullYear()+1; setForm({yearStart:yr,yearLabel:`${yr}/${(yr+1)%100}`,startDate:`${yr}-04-01`,endDate:`${yr+1}-03-31`,q1Deadline:`${yr}-07-15`,q2Deadline:`${yr}-10-15`,q3Deadline:`${yr+1}-01-15`,q4Deadline:`${yr+1}-04-15`,kpiDeadlineDays:14}); setModal('add'); };
  const openEdit = (fy) => { setForm({...fy, startDate:fy.startDate?.split('T')[0],endDate:fy.endDate?.split('T')[0],q1Deadline:fy.q1Deadline?.split('T')[0],q2Deadline:fy.q2Deadline?.split('T')[0],q3Deadline:fy.q3Deadline?.split('T')[0],q4Deadline:fy.q4Deadline?.split('T')[0]}); setModal('edit'); };
  const handleSave = async () => { try { if (modal==='add') await financialYearsApi.create(form); else await financialYearsApi.update(form.id,form); setModal(null); load(); } catch(e) { alert('Error: '+(e.response?.data?.error||e.message)); } };
  const setCurrent = async (id) => { try { await financialYearsApi.setCurrent(id); load(); } catch {} };
  const toggleLock = async (fy) => { try { if(fy.isLocked) await financialYearsApi.unlock(fy.id); else await financialYearsApi.lock(fy.id); load(); } catch {} };
  const handleDelete = async (id) => { if(window.confirm('Delete this financial year?')) { await financialYearsApi.delete(id).catch(()=>{}); load(); }};

  return (
    <div>
      <div className="flex items-center justify-between mb-5">
        <div><p className="text-sm text-slate-500">{years.length} financial years configured</p><p className="text-[10px] text-slate-400 mt-0.5">Set quarter deadlines, lock/unlock periods, and mark the current active FY</p></div>
        <button onClick={openAdd} className={btnPrimary}><span className="text-lg leading-none">+</span> Add Financial Year</button>
      </div>
      <div className="space-y-3">
        {years.map(fy => (
          <div key={fy.id} className={`bg-white rounded-2xl border ${fy.isCurrent ? 'border-[#c8102e] ring-2 ring-[#c8102e]/20' : 'border-slate-200'} overflow-hidden`}>
            <div className="p-5">
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-3">
                  <span className="text-2xl font-black text-slate-800">FY {fy.yearLabel}</span>
                  {fy.isCurrent && <span className="px-2.5 py-1 bg-[#c8102e] text-white rounded-full text-[10px] font-bold uppercase">Current</span>}
                  {fy.isLocked && <span className="px-2.5 py-1 bg-amber-100 text-amber-700 rounded-full text-[10px] font-bold uppercase">🔒 Locked</span>}
                </div>
                <div className="flex gap-2">
                  {!fy.isCurrent && <button onClick={()=>setCurrent(fy.id)} className="px-3 py-1.5 bg-blue-50 text-blue-700 rounded-xl text-xs font-semibold hover:bg-blue-100">Set Current</button>}
                  <button onClick={()=>toggleLock(fy)} className={`px-3 py-1.5 rounded-xl text-xs font-semibold ${fy.isLocked?'bg-emerald-50 text-emerald-700 hover:bg-emerald-100':'bg-amber-50 text-amber-700 hover:bg-amber-100'}`}>{fy.isLocked?'🔓 Unlock':'🔒 Lock'}</button>
                  <button onClick={()=>openEdit(fy)} className="text-xs text-slate-400 hover:text-slate-600 p-1.5">✏️</button>
                  <button onClick={()=>handleDelete(fy.id)} className="text-xs text-red-400 hover:text-red-600 p-1.5">🗑️</button>
                </div>
              </div>
              <div className="grid grid-cols-2 lg:grid-cols-6 gap-3 text-xs">
                <div className="bg-slate-50 rounded-xl p-3"><p className="text-[10px] text-slate-400 uppercase font-bold">Start</p><p className="text-slate-700 font-semibold">{fmtDate(fy.startDate)}</p></div>
                <div className="bg-slate-50 rounded-xl p-3"><p className="text-[10px] text-slate-400 uppercase font-bold">End</p><p className="text-slate-700 font-semibold">{fmtDate(fy.endDate)}</p></div>
                <div className="bg-blue-50 rounded-xl p-3"><p className="text-[10px] text-blue-500 uppercase font-bold">Q1 Deadline</p><p className="text-slate-700 font-semibold">{fmtDate(fy.q1Deadline)}</p></div>
                <div className="bg-blue-50 rounded-xl p-3"><p className="text-[10px] text-blue-500 uppercase font-bold">Q2 Deadline</p><p className="text-slate-700 font-semibold">{fmtDate(fy.q2Deadline)}</p></div>
                <div className="bg-blue-50 rounded-xl p-3"><p className="text-[10px] text-blue-500 uppercase font-bold">Q3 Deadline</p><p className="text-slate-700 font-semibold">{fmtDate(fy.q3Deadline)}</p></div>
                <div className="bg-blue-50 rounded-xl p-3"><p className="text-[10px] text-blue-500 uppercase font-bold">Q4 Deadline</p><p className="text-slate-700 font-semibold">{fmtDate(fy.q4Deadline)}</p></div>
              </div>
            </div>
          </div>
        ))}
        {years.length===0 && <div className="bg-white rounded-2xl border p-12 text-center text-slate-400">No financial years configured yet</div>}
      </div>
      <Modal open={!!modal} onClose={()=>setModal(null)} title={modal==='add'?'Add Financial Year':'Edit Financial Year'} wide>
        <div className="space-y-4">
          <div className="grid grid-cols-3 gap-3">
            <Field label="Year Start (e.g. 2026)" required><input type="number" className={input} value={form.yearStart||''} onChange={e=>{ const yr=+e.target.value; setForm({...form,yearStart:yr,yearLabel:`${yr}/${(yr+1)%100}`}); }} /></Field>
            <Field label="Label"><input className={input} value={form.yearLabel||''} onChange={e=>setForm({...form,yearLabel:e.target.value})} /></Field>
            <Field label="KPI Deadline Days"><input type="number" className={input} value={form.kpiDeadlineDays||14} onChange={e=>setForm({...form,kpiDeadlineDays:+e.target.value})} /></Field>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <Field label="Start Date" required><input type="date" className={input} value={form.startDate||''} onChange={e=>setForm({...form,startDate:e.target.value})} /></Field>
            <Field label="End Date" required><input type="date" className={input} value={form.endDate||''} onChange={e=>setForm({...form,endDate:e.target.value})} /></Field>
          </div>
          <div className="bg-blue-50 rounded-xl p-4"><p className="text-xs font-bold text-blue-600 uppercase mb-3">Quarter Submission Deadlines</p>
            <div className="grid grid-cols-4 gap-3">
              <Field label="Q1 Deadline"><input type="date" className={input} value={form.q1Deadline||''} onChange={e=>setForm({...form,q1Deadline:e.target.value})} /></Field>
              <Field label="Q2 Deadline"><input type="date" className={input} value={form.q2Deadline||''} onChange={e=>setForm({...form,q2Deadline:e.target.value})} /></Field>
              <Field label="Q3 Deadline"><input type="date" className={input} value={form.q3Deadline||''} onChange={e=>setForm({...form,q3Deadline:e.target.value})} /></Field>
              <Field label="Q4 Deadline"><input type="date" className={input} value={form.q4Deadline||''} onChange={e=>setForm({...form,q4Deadline:e.target.value})} /></Field>
            </div>
          </div>
          <div className="flex justify-end gap-2 pt-2"><button onClick={()=>setModal(null)} className={btnSecondary}>Cancel</button><button onClick={handleSave} className={btnPrimary}>💾 {modal==='add'?'Create':'Save'}</button></div>
        </div>
      </Modal>
    </div>
  );
}

// ════════════════════════════════════════
// TAB: ROLE RATES (Phase 1 — Project Management)
// ════════════════════════════════════════
// Admin-managed rate card. PMs pick a RoleRate when assigning resources to a
// project (Phase 2 will wire this into the Resources tab); cost = hours × rate.
// Currency defaults to ZAR but is left open for future multi-currency use.
function RoleRatesTab() {
  const [rates, setRates] = useState([]);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({});
  const [showInactive, setShowInactive] = useState(false);
  const [categoryFilter, setCategoryFilter] = useState('');

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [showInactive, categoryFilter]);
  const load = () => roleRatesApi.getAll({ includeInactive: showInactive, category: categoryFilter || undefined })
    .then(r => setRates(r.data || []))
    .catch(() => setRates([]));

  const fmtDate = d => d ? new Date(d).toLocaleDateString('en-ZA', {day:'numeric',month:'short',year:'numeric'}) : '—';
  const fmtR = v => v == null ? '—' : `R ${Number(v).toLocaleString('en-ZA', {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;

  const openAdd = () => {
    setForm({
      code: '', name: '', description: '',
      hourlyRate: 0, currency: 'ZAR',
      effectiveFrom: new Date().toISOString().split('T')[0],
      effectiveTo: '', isActive: true, category: 'Technical'
    });
    setModal('add');
  };
  const openEdit = (r) => {
    setForm({
      ...r,
      effectiveFrom: r.effectiveFrom?.split('T')[0] || '',
      effectiveTo: r.effectiveTo?.split('T')[0] || '',
    });
    setModal('edit');
  };

  const handleSave = async () => {
    try {
      const payload = {
        ...form,
        hourlyRate: parseFloat(form.hourlyRate) || 0,
        currency: form.currency?.trim() || 'ZAR',
        effectiveFrom: form.effectiveFrom || null,
        effectiveTo: form.effectiveTo || null,
      };
      if (modal === 'add') await roleRatesApi.create(payload);
      else await roleRatesApi.update(form.id, payload);
      setModal(null);
      load();
    } catch (e) {
      alert('Error: ' + (e.response?.data?.error || e.message));
    }
  };

  const handleDelete = async (id, name) => {
    if (!window.confirm(`Archive role rate "${name}"?\n\nHistorical project costs already computed from this rate will be preserved.`)) return;
    try { await roleRatesApi.delete(id); load(); } catch (e) { alert('Error: ' + (e.response?.data?.error || e.message)); }
  };

  // Group by category for display
  const grouped = rates.reduce((acc, r) => {
    const cat = r.category || 'Uncategorised';
    (acc[cat] = acc[cat] || []).push(r);
    return acc;
  }, {});
  const categories = ['Technical', 'Management', 'Support', 'Uncategorised'];

  return (
    <div>
      <div className="flex items-center justify-between mb-5 flex-wrap gap-3">
        <div>
          <p className="text-sm text-slate-500">{rates.length} {rates.length === 1 ? 'role rate' : 'role rates'} {showInactive ? '(including inactive)' : 'active'}</p>
          <p className="text-[10px] text-slate-400 mt-0.5">Defines the cost per hour for each role. Project Managers pick from this list when assigning resources.</p>
        </div>
        <div className="flex items-center gap-3">
          <label className="flex items-center gap-2 text-xs text-slate-600">
            <input type="checkbox" checked={showInactive} onChange={e => setShowInactive(e.target.checked)} className="rounded"/>
            Show inactive
          </label>
          <button onClick={openAdd} className={btnPrimary}>
            <span className="text-lg leading-none">+</span> Add Role Rate
          </button>
        </div>
      </div>

      {rates.length === 0 ? (
        <div className="bg-white rounded-2xl border p-12 text-center text-slate-400">
          <p className="text-sm">No role rates configured yet.</p>
          <p className="text-[11px] text-slate-400 mt-1">Add a role rate to let PMs assign resources and compute labour cost.</p>
        </div>
      ) : (
        <div className="space-y-6">
          {categories.map(cat => {
            const group = grouped[cat];
            if (!group || group.length === 0) return null;
            return (
              <div key={cat}>
                <div className="flex items-center gap-2 mb-2 px-1">
                  <div className="w-2 h-2 rounded-full bg-[#c8102e]"/>
                  <span className="text-xs font-bold text-[#a30d24] uppercase tracking-wider">{cat}</span>
                  <span className="text-[10px] text-slate-400">({group.length})</span>
                </div>
                <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="bg-slate-50 border-b border-slate-200">
                        <th className="px-4 py-2.5 text-left text-[10px] font-bold text-slate-500 uppercase tracking-wider">Code</th>
                        <th className="px-4 py-2.5 text-left text-[10px] font-bold text-slate-500 uppercase tracking-wider">Name</th>
                        <th className="px-4 py-2.5 text-right text-[10px] font-bold text-slate-500 uppercase tracking-wider">Hourly Rate</th>
                        <th className="px-4 py-2.5 text-left text-[10px] font-bold text-slate-500 uppercase tracking-wider">Effective From</th>
                        <th className="px-4 py-2.5 text-left text-[10px] font-bold text-slate-500 uppercase tracking-wider">Effective To</th>
                        <th className="px-4 py-2.5 text-center text-[10px] font-bold text-slate-500 uppercase tracking-wider">Status</th>
                        <th className="px-4 py-2.5 text-right text-[10px] font-bold text-slate-500 uppercase tracking-wider w-24">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {group.map(r => (
                        <tr key={r.id} className="border-t border-slate-100 hover:bg-slate-50/50">
                          <td className="px-4 py-3 font-mono text-xs font-bold text-[#c8102e]">{r.code}</td>
                          <td className="px-4 py-3">
                            <div className="font-semibold text-slate-800">{r.name}</div>
                            {r.description && <div className="text-[11px] text-slate-500 mt-0.5">{r.description}</div>}
                          </td>
                          <td className="px-4 py-3 text-right font-mono font-bold text-slate-800">
                            {fmtR(r.hourlyRate)}<span className="text-[10px] text-slate-400 ml-1">{r.currency || 'ZAR'}</span>
                          </td>
                          <td className="px-4 py-3 text-xs text-slate-600">{fmtDate(r.effectiveFrom)}</td>
                          <td className="px-4 py-3 text-xs text-slate-600">{fmtDate(r.effectiveTo)}</td>
                          <td className="px-4 py-3 text-center">
                            {r.isActive
                              ? <span className="px-2 py-0.5 bg-red-50 text-[#a30d24] rounded-full text-[10px] font-bold uppercase">Active</span>
                              : <span className="px-2 py-0.5 bg-slate-100 text-slate-500 rounded-full text-[10px] font-bold uppercase">Inactive</span>}
                          </td>
                          <td className="px-4 py-3 text-right whitespace-nowrap">
                            <button onClick={() => openEdit(r)} className="text-xs text-slate-500 hover:text-[#c8102e] p-1.5" title="Edit">✏️</button>
                            <button onClick={() => handleDelete(r.id, r.name)} className="text-xs text-slate-400 hover:text-red-600 p-1.5" title="Archive">🗑️</button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            );
          })}
        </div>
      )}

      <Modal open={!!modal} onClose={() => setModal(null)} title={modal === 'add' ? 'Add Role Rate' : 'Edit Role Rate'} wide>
        <div className="space-y-1">
          <div className="grid grid-cols-3 gap-3">
            <Field label="Code" required hint="Short unique code, e.g. SR_RES, PM">
              <input className={input} value={form.code || ''} onChange={e => setForm({...form, code: e.target.value.toUpperCase().replace(/\s+/g, '_')})} placeholder="e.g. PM" />
            </Field>
            <Field label="Category">
              <select className={input} value={form.category || 'Technical'} onChange={e => setForm({...form, category: e.target.value})}>
                <option>Technical</option>
                <option>Management</option>
                <option>Support</option>
                <option>Uncategorised</option>
              </select>
            </Field>
            <Field label="Currency" hint="ZAR by default">
              <input className={input} value={form.currency || 'ZAR'} onChange={e => setForm({...form, currency: e.target.value.toUpperCase()})} />
            </Field>
          </div>
          <Field label="Name" required>
            <input className={input} value={form.name || ''} onChange={e => setForm({...form, name: e.target.value})} placeholder="e.g. Senior Researcher" />
          </Field>
          <Field label="Description" hint="What this role typically does on a project">
            <textarea className={input + ' h-20'} value={form.description || ''} onChange={e => setForm({...form, description: e.target.value})} />
          </Field>
          <div className="grid grid-cols-3 gap-3">
            <Field label="Hourly Rate" required hint="Cost per hour">
              <input type="number" step="0.01" min="0" className={input} value={form.hourlyRate || ''} onChange={e => setForm({...form, hourlyRate: e.target.value})} />
            </Field>
            <Field label="Effective From" required>
              <input type="date" className={input} value={form.effectiveFrom || ''} onChange={e => setForm({...form, effectiveFrom: e.target.value})} />
            </Field>
            <Field label="Effective To" hint="Leave blank if open-ended">
              <input type="date" className={input} value={form.effectiveTo || ''} onChange={e => setForm({...form, effectiveTo: e.target.value})} />
            </Field>
          </div>
          <div className="bg-blue-50 rounded-xl p-3 mt-2">
            <label className="flex items-center gap-2 text-xs text-slate-700">
              <input type="checkbox" checked={form.isActive !== false} onChange={e => setForm({...form, isActive: e.target.checked})} className="rounded"/>
              <span className="font-semibold">Active</span>
              <span className="text-slate-500">— uncheck to archive this rate without deleting it</span>
            </label>
          </div>
          <div className="flex justify-end gap-2 pt-4">
            <button onClick={() => setModal(null)} className={btnSecondary}>Cancel</button>
            <button onClick={handleSave} className={btnPrimary}>💾 {modal === 'add' ? 'Create' : 'Save'}</button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

// ════════════════════════════════════════
// MAIN ADMIN SETUP PAGE
// ════════════════════════════════════════
// ════════════════════════════════════════
// TAB: RESEARCH THEMES (V3.1 — admin-managed lookup for R&D Projects)
// "Research Theme must be specified by the Admin" (Remove_OWNING_DIVISION2.docx)
// ════════════════════════════════════════
function ResearchThemesTab() {
  const [themes, setThemes] = useState([]);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({ name: '', code: '', description: '', sortOrder: 0, isActive: true });
  const [editingId, setEditingId] = useState(null);

  const load = () => researchThemesApi.getAll(false).then(r => setThemes(r.data || [])).catch(() => setThemes([]));
  useEffect(() => { load(); }, []);

  const openAdd = () => { setForm({ name: '', code: '', description: '', sortOrder: (themes.length + 1) * 10, isActive: true }); setEditingId(null); setModal('add'); };
  const openEdit = (t) => { setForm({ name: t.name || '', code: t.code || '', description: t.description || '', sortOrder: t.sortOrder ?? 0, isActive: t.isActive !== false }); setEditingId(t.id); setModal('add'); };
  const save = async () => {
    try {
      const payload = { ...form, sortOrder: parseInt(form.sortOrder) || 0 };
      if (editingId) await researchThemesApi.update(editingId, payload);
      else await researchThemesApi.create(payload);
      setModal(null); setEditingId(null); load();
    } catch (e) { alert('Error: ' + (e.response?.data?.error || e.message)); }
  };
  const remove = async (t) => {
    if (!window.confirm(`Delete "${t.name}"? Themes used by R&D projects cannot be deleted — mark them as inactive instead.`)) return;
    try { await researchThemesApi.delete(t.id); load(); }
    catch (e) { alert(e.response?.data?.error || e.message); }
  };
  const toggleActive = async (t) => {
    try { await researchThemesApi.update(t.id, { ...t, isActive: !t.isActive }); load(); }
    catch (e) { alert(e.response?.data?.error || e.message); }
  };

  return (
    <div className="bg-white rounded-2xl shadow-sm border p-5">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="text-lg font-bold text-slate-800">Research Themes</h2>
          <p className="text-sm text-slate-500">Master list of research themes available on the R&amp;D Projects form. Inactive themes stay on existing projects but no longer appear in the dropdown.</p>
        </div>
        <button onClick={openAdd} className={btnPrimary}><span className="text-lg leading-none">+</span> Add Theme</button>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-slate-50 border-b border-slate-200">
              <th className="px-3 py-2.5 text-left text-[11px] font-bold text-slate-500 uppercase tracking-wider w-16">Order</th>
              <th className="px-3 py-2.5 text-left text-[11px] font-bold text-slate-500 uppercase tracking-wider w-28">Code</th>
              <th className="px-3 py-2.5 text-left text-[11px] font-bold text-slate-500 uppercase tracking-wider">Name</th>
              <th className="px-3 py-2.5 text-left text-[11px] font-bold text-slate-500 uppercase tracking-wider">Description</th>
              <th className="px-3 py-2.5 text-center text-[11px] font-bold text-slate-500 uppercase tracking-wider w-24">Status</th>
              <th className="px-3 py-2.5 text-right text-[11px] font-bold text-slate-500 uppercase tracking-wider w-28">Actions</th>
            </tr>
          </thead>
          <tbody>
            {themes.map(t => (
              <tr key={t.id} className="border-b border-slate-100 hover:bg-slate-50/60">
                <td className="px-3 py-2.5 text-slate-500 font-mono text-xs">{t.sortOrder}</td>
                <td className="px-3 py-2.5"><span className="font-mono text-[11px] text-slate-700 px-2 py-0.5 bg-slate-100 rounded">{t.code || '—'}</span></td>
                <td className="px-3 py-2.5 font-semibold text-slate-800">{t.name}</td>
                <td className="px-3 py-2.5 text-slate-500 text-xs max-w-md truncate">{t.description || '—'}</td>
                <td className="px-3 py-2.5 text-center">
                  <button
                    onClick={() => toggleActive(t)}
                    className={`px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wide ${t.isActive ? 'bg-emerald-100 text-emerald-700 hover:bg-emerald-200' : 'bg-slate-100 text-slate-500 hover:bg-slate-200'}`}
                    title="Click to toggle"
                  >
                    {t.isActive ? 'Active' : 'Inactive'}
                  </button>
                </td>
                <td className="px-3 py-2.5 text-right">
                  <button onClick={() => openEdit(t)} className="text-slate-400 hover:text-slate-700 mx-1" title="Edit">✏️</button>
                  <button onClick={() => remove(t)} className="text-red-400 hover:text-red-600 mx-1" title="Delete">🗑️</button>
                </td>
              </tr>
            ))}
            {themes.length === 0 && (
              <tr><td colSpan={6} className="px-4 py-12 text-center text-slate-400 text-sm">No research themes defined yet. Click "+ Add Theme" to create the first one.</td></tr>
            )}
          </tbody>
        </table>
      </div>

      <Modal open={modal === 'add'} onClose={() => { setModal(null); setEditingId(null); }} title={editingId ? 'Edit Research Theme' : 'Add Research Theme'}>
        <Field label="Name" required>
          <input className={input} value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} placeholder="e.g. Minerals Beneficiation" />
        </Field>
        <Field label="Code" hint="Short code shown in the R&D dropdown, e.g. MIN-BEN">
          <input className={input} value={form.code} onChange={e => setForm(f => ({ ...f, code: e.target.value.toUpperCase() }))} placeholder="MIN-BEN" />
        </Field>
        <Field label="Description">
          <textarea className={input + ' h-20'} value={form.description} onChange={e => setForm(f => ({ ...f, description: e.target.value }))} />
        </Field>
        <div className="grid grid-cols-2 gap-3">
          <Field label="Sort Order" hint="Lower numbers appear first in the dropdown">
            <input type="number" className={input} value={form.sortOrder} onChange={e => setForm(f => ({ ...f, sortOrder: e.target.value }))} />
          </Field>
          <Field label="Status">
            <select className={input} value={form.isActive ? 'true' : 'false'} onChange={e => setForm(f => ({ ...f, isActive: e.target.value === 'true' }))}>
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </select>
          </Field>
        </div>
        <div className="flex justify-end gap-2 mt-2">
          <button onClick={() => { setModal(null); setEditingId(null); }} className={btnSecondary}>Cancel</button>
          <button onClick={save} className={btnPrimary} disabled={!form.name?.trim()}>{editingId ? 'Save Changes' : 'Create Theme'}</button>
        </div>
      </Modal>
    </div>
  );
}

// ════════════════════════════════════════
// TAB: MOTIVATION TOPICS (V3.1 — admin-managed list for R&D Research Motivation form)
// "Where does the admin set the topics for the motivation" (Remove_OWNING_DIVISION2.docx)
// Replaces the previously-hardcoded GOVT_PRIORITIES list.
// ════════════════════════════════════════
function MotivationTopicsTab() {
  const [topics, setTopics] = useState([]);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({ name: '', description: '', category: 'Government Priorities', sortOrder: 0, isActive: true });
  const [editingId, setEditingId] = useState(null);
  const [filterCat, setFilterCat] = useState('');

  const load = () => motivationTopicsApi.getAll(false).then(r => setTopics(r.data || [])).catch(() => setTopics([]));
  useEffect(() => { load(); }, []);

  const categories = Array.from(new Set(topics.map(t => t.category).filter(Boolean))).sort();
  const visible = filterCat ? topics.filter(t => t.category === filterCat) : topics;
  // Group by category for display
  const grouped = visible.reduce((acc, t) => { const k = t.category || '(Uncategorised)'; (acc[k] = acc[k] || []).push(t); return acc; }, {});

  const openAdd = () => {
    setForm({ name: '', description: '', category: filterCat || 'Government Priorities', sortOrder: (topics.length + 1) * 10, isActive: true });
    setEditingId(null); setModal('add');
  };
  const openEdit = (t) => {
    setForm({ name: t.name || '', description: t.description || '', category: t.category || '', sortOrder: t.sortOrder ?? 0, isActive: t.isActive !== false });
    setEditingId(t.id); setModal('add');
  };
  const save = async () => {
    try {
      const payload = { ...form, sortOrder: parseInt(form.sortOrder) || 0 };
      if (editingId) await motivationTopicsApi.update(editingId, payload);
      else await motivationTopicsApi.create(payload);
      setModal(null); setEditingId(null); load();
    } catch (e) { alert('Error: ' + (e.response?.data?.error || e.message)); }
  };
  const remove = async (t) => {
    if (!window.confirm(`Delete "${t.name}"? Existing R&D projects keep their captured selections.`)) return;
    try { await motivationTopicsApi.delete(t.id); load(); }
    catch (e) { alert(e.response?.data?.error || e.message); }
  };
  const toggleActive = async (t) => {
    try { await motivationTopicsApi.update(t.id, { ...t, isActive: !t.isActive }); load(); }
    catch (e) { alert(e.response?.data?.error || e.message); }
  };

  return (
    <div className="bg-white rounded-2xl shadow-sm border p-5">
      <div className="flex items-start justify-between mb-4 flex-wrap gap-3">
        <div>
          <h2 className="text-lg font-bold text-slate-800">Motivation Topics</h2>
          <p className="text-sm text-slate-500 max-w-2xl">Master list of topics/priorities researchers tick when motivating an R&amp;D project. Group related topics with a Category (e.g. "Government Priorities", "Mintek Strategic Pillars"). Inactive topics no longer appear on new projects.</p>
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          <select className={input + ' max-w-[220px]'} value={filterCat} onChange={e => setFilterCat(e.target.value)}>
            <option value="">All categories</option>
            {categories.map(c => <option key={c} value={c}>{c}</option>)}
          </select>
          <button onClick={openAdd} className={btnPrimary}><span className="text-lg leading-none">+</span> Add Topic</button>
        </div>
      </div>

      {Object.keys(grouped).sort().map(cat => (
        <div key={cat} className="mb-6">
          <div className="flex items-center gap-2 mb-2">
            <span className="text-[11px] font-bold uppercase tracking-wider text-[#a30d24]">{cat}</span>
            <span className="text-[10px] text-slate-400">({grouped[cat].length} topic{grouped[cat].length === 1 ? '' : 's'})</span>
            <div className="flex-1 h-px bg-slate-200" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
            {grouped[cat].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0)).map(t => (
              <div key={t.id} className={`flex items-start gap-3 p-3 rounded-xl border ${t.isActive ? 'border-slate-200 bg-white' : 'border-slate-200 bg-slate-50/70 opacity-70'}`}>
                <div className="font-mono text-[10px] text-slate-400 w-8 pt-0.5">{t.sortOrder}</div>
                <div className="flex-1 min-w-0">
                  <p className="font-semibold text-sm text-slate-800">{t.name}</p>
                  {t.description && <p className="text-xs text-slate-500 mt-0.5 line-clamp-2">{t.description}</p>}
                </div>
                <button onClick={() => toggleActive(t)} className={`px-2 py-0.5 rounded-full text-[9px] font-bold uppercase tracking-wide shrink-0 ${t.isActive ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-200 text-slate-500'}`}>{t.isActive ? 'Active' : 'Inactive'}</button>
                <div className="flex gap-1 shrink-0">
                  <button onClick={() => openEdit(t)} className="text-slate-400 hover:text-slate-700" title="Edit">✏️</button>
                  <button onClick={() => remove(t)} className="text-red-400 hover:text-red-600" title="Delete">🗑️</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}

      {topics.length === 0 && (
        <div className="text-center py-12 text-slate-400">
          <p className="text-sm mb-2">No motivation topics defined yet.</p>
          <p className="text-xs">Click "+ Add Topic" to seed the list. Researchers will then see these on the R&amp;D Motivation form instead of the legacy hardcoded priorities.</p>
        </div>
      )}

      <Modal open={modal === 'add'} onClose={() => { setModal(null); setEditingId(null); }} title={editingId ? 'Edit Motivation Topic' : 'Add Motivation Topic'}>
        <Field label="Name" required>
          <input className={input} value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} placeholder="e.g. Beneficiation of mineral resources" />
        </Field>
        <Field label="Category" hint="Used to group topics on the motivation form. Pick an existing one or type a new one.">
          <input className={input} list="motivation-categories" value={form.category} onChange={e => setForm(f => ({ ...f, category: e.target.value }))} placeholder="Government Priorities" />
          <datalist id="motivation-categories">
            {categories.map(c => <option key={c} value={c} />)}
          </datalist>
        </Field>
        <Field label="Description">
          <textarea className={input + ' h-20'} value={form.description} onChange={e => setForm(f => ({ ...f, description: e.target.value }))} placeholder="Optional — context shown as a tooltip on the form" />
        </Field>
        <div className="grid grid-cols-2 gap-3">
          <Field label="Sort Order" hint="Lower numbers appear first within the category">
            <input type="number" className={input} value={form.sortOrder} onChange={e => setForm(f => ({ ...f, sortOrder: e.target.value }))} />
          </Field>
          <Field label="Status">
            <select className={input} value={form.isActive ? 'true' : 'false'} onChange={e => setForm(f => ({ ...f, isActive: e.target.value === 'true' }))}>
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </select>
          </Field>
        </div>
        <div className="flex justify-end gap-2 mt-2">
          <button onClick={() => { setModal(null); setEditingId(null); }} className={btnSecondary}>Cancel</button>
          <button onClick={save} className={btnPrimary} disabled={!form.name?.trim()}>{editingId ? 'Save Changes' : 'Create Topic'}</button>
        </div>
      </Modal>
    </div>
  );
}

const TABS = [
  { key: 'objectives', label: 'Strategic Objectives', icon: '🎯' },
  { key: 'programmes', label: 'RDI & Industry Programmes', icon: '⚡' },
  { key: 'clusters', label: 'Technical Clusters', icon: '⚗️' },
  { key: 'support', label: 'Support Services Cluster', icon: '🏢' },
  { key: 'rdiops', label: 'RDI Operational Services', icon: '📊' },
  { key: 'kpis', label: 'KPI Definitions', icon: '📊' },
  { key: 'researchthemes', label: 'Research Themes', icon: '🔬' }, // V3.1
  { key: 'motivationtopics', label: 'Motivation Topics', icon: '💡' }, // V3.1
  { key: 'taxonomy', label: 'Risk Taxonomy', icon: '🛡️' },
  { key: 'financialyears', label: 'Financial Years', icon: '📅' },
  { key: 'rolerates', label: 'Role Rates', icon: '💰' },
];

export default function AdminSetupPage() {
  const [tab, setTab] = useState('objectives');
  return (
    <div className="silogate-admin relative space-y-6">
      <style>{ADMIN_PAGE_CSS}</style>
      <div className="flex items-start justify-between">
        <div>
          <h1 className="admin-title">System Administration</h1>
          <p className="admin-subtitle">Configure strategic objectives, programmes, KPIs and organisational structure</p>
        </div>
        <div className="hidden md:flex items-center gap-2">
          <button className="h-10 px-3 rounded-xl border border-slate-400 bg-gradient-to-b from-white to-slate-200 shadow-lg text-slate-600">👤⌄</button>
          <button className="h-10 px-3 rounded-xl border border-slate-400 bg-gradient-to-b from-white to-slate-200 shadow-lg text-slate-600">⚙⌄</button>
        </div>
      </div>

      <div className="admin-tabs flex overflow-x-auto">
        {TABS.map(t => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            className={`admin-tab flex items-center gap-2 ${tab === t.key ? 'admin-tab-active' : ''}`}
          >
            <span className="opacity-90">{t.icon}</span> {t.label}
          </button>
        ))}
      </div>

      <span className="mintek-watermark">Mintek</span>

      {tab === 'objectives' && <ObjectivesTab />}
      {tab === 'programmes' && <ProgrammesTab />}
      {tab === 'clusters' && <TechnicalClustersTab />}
      {tab === 'support' && <SupportServicesTab />}
      {tab === 'rdiops' && <RdiOperationalServicesTab />}
      {tab === 'kpis' && <KpiDefinitionsTab />}
      {tab === 'researchthemes' && <ResearchThemesTab />}
      {tab === 'motivationtopics' && <MotivationTopicsTab />}
      {tab === 'taxonomy' && <TaxonomyTab />}
      {tab === 'financialyears' && <FinancialYearsTab />}
      {tab === 'rolerates' && <RoleRatesTab />}
    </div>
  );
}
